{
  "version": 1,
  "asset_id": "327a4490-f83f-4b2a-b00d-726ae57316ee",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/327a4490-f83f-4b2a-b00d-726ae57316ee/bahcesehir-hizli-elektrikci-7-24-dukkan-7.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/327a4490-f83f-4b2a-b00d-726ae57316ee/bahcesehir-hizli-elektrikci-7-24-dukkan-7.jpg",
  "original_filename": "bahcesehir-hizli-elektrikci-7-24-dukkan-7.jpg",
  "size": 445040,
  "content_type": "image/jpeg",
  "created_at": "2026-09-11T16:19:00Z"
}
